import React from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

type ButtonProps = {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  variant?: ButtonVariant;
  fullWidth?: boolean;
};

const getVariantStyles = (variant: ButtonVariant): React.CSSProperties => {
  switch (variant) {
    case "secondary":
      return {
        background: "var(--surface-alt)",
        color: "var(--text-primary)",
        border: "1px solid var(--border)",
      };

    case "ghost":
      return {
        background: "transparent",
        color: "var(--text-primary)",
        border: "1px solid transparent",
      };

    case "danger":
      return {
        background: "var(--danger)",
        color: "#ffffff",
        border: "1px solid transparent",
      };

    case "primary":
    default:
      return {
        background: "var(--primary)",
        color: "#ffffff",
        border: "1px solid transparent",
      };
  }
};

const Button = ({
  children,
  type = "button",
  onClick,
  disabled = false,
  className = "",
  style,
  variant = "primary",
  fullWidth = false,
}: ButtonProps) => {
  const variantStyles = getVariantStyles(variant);

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        width: fullWidth ? "100%" : "auto",
        minHeight: "46px",
        padding: "12px 16px",
        borderRadius: "16px",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: "15px",
        fontWeight: 700,
        boxShadow: variant === "ghost" ? "none" : "var(--shadow)",
        transition: "all var(--transition-base)",
        opacity: disabled ? 0.7 : 1,
        ...variantStyles,
        ...style,
      }}
    >
      {children}
    </button>
  );
};

export default Button;